<template>
  <section class="container d-none d-lg-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li
          v-for="(breadcrumb, idx) in breadcrumbs"
          :key="idx"
        >
          <router-link
            :to="breadcrumb.link"
            v-if="breadcrumb.link"
          >
            <span>{{ breadcrumb.name }}</span>
          </router-link>

          <p class="breadcrumb-no-link" v-else>
            <span>{{ breadcrumb.name }}</span>
          </p>

        </li>
      </ol>
    </nav>
  </section>
  <!-- /.container -->
</template>

<script>
  export default {
    name: 'Breadcrumb',
    props: {
      breadcrumbs: Array
    }
  };
</script>

<style scoped lang="scss">
  .breadcrumb {
    margin-top: 30px;

    font-family: 'Lato', sans-serif;
    font-size: 18px;
    font-weight: 300;

    background-color: #ffffff;

    li {
      margin-left: 5px;

      &:not(:last-child) {
        a {
          display: inline-block;
          padding-right: 5px;
        }

        &::after {
          content: '/';

          color: #333333;
        }
      }
    }

    .linked {
      color: #04a4ee;

      cursor: pointer;
    }
  }

  .breadcrumb-no-link {
    margin: 0;
  }
</style>
